/**
 * The student record's stored values in the registrar's words, and the
 * choices its reasoned acts offer.
 */
import type { ConversionRestoreStage, SidIssuance, StudentStanding } from "@/lib/api/students";

/** The standings a registrar sets by choice; withdrawal is its own act. */
export const STANDINGS: readonly StudentStanding[] = ["active", "leave_of_absence", "completed"];

export const GENDERS: ReadonlyArray<{ value: string; label: string }> = [
  { value: "M", label: "Male" },
  { value: "F", label: "Female" },
];

export function genderLabel(value: string | null): string {
  return GENDERS.find((gender) => gender.value === value)?.label ?? "Not recorded";
}

/** Where the cohort year of an issued Student ID was read from. */
export const ISSUANCE_SOURCE_LABEL: Record<SidIssuance["cohort_year_source"], string> = {
  applicant_round: "the admission round",
  applicant_applied_date: "the date the application arrived",
  current_year: "the year the record was made",
};

/** The stages a mistaken conversion returns the application to. */
export const CORRECTION_STAGES: readonly ConversionRestoreStage[] = [
  "Applied",
  "Under Review",
  "Interview Invited",
  "Decision Pending",
  "Waitlisted",
  "Denied",
];
